// extracted by mini-css-extract-plugin
module.exports = {"code-validation":"CodeValidation_code-validation__10dtZ"};